import { render, staticRenderFns } from "./comPromote.vue?vue&type=template&id=60b22c08&scoped=true"
import script from "./comPromote.vue?vue&type=script&lang=js"
export * from "./comPromote.vue?vue&type=script&lang=js"
import style0 from "./comPromote.vue?vue&type=style&index=0&id=60b22c08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b22c08",
  null
  
)

export default component.exports